import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCanLoadGuard } from './auth/_guards';
import { CanDeactivateGuard } from './auth/_guards/auth.can-deactivate-guard.service';
import { HomeComponent } from './home/home.component';
import {extendAppRoutingModuleRoutes } from '@custom/core/app-routing-module-handler';
import { AuthenticationResolver } from './auth/authentication.resolver';
import {SftpTrackerDashboardRoutingModule} from './sftptrackerdashboard/sftptrackerdashboard-routing.module';
import { DailySyncDashboardRoutingModule } from './dailysyncdashboard/dailysyncdashboard-routing.module';
import { SapDetailsRoutingModule } from './sap-detailsdashboard/sap-details-routing.module';
let routes: Routes = [  
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },  
  {
    path: 'home',
    component: HomeComponent,
    canLoad: [ AuthCanLoadGuard ],
    data: {
    	breadcrumb: 'Home',
    	label: 'Home'
    },
	resolve:{
		authResolver:AuthenticationResolver
	},
    children: [
      {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full'
      }, {
        path: 'landing',
		redirectTo: 'results'
    //     loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
    //     data: {
    // 		breadcrumb: 'Landing',
    // 		label: 'Landing'
    //   },
      },
      {
		path: 'devcenter',
		canLoad: [ AuthCanLoadGuard ],
		data: {
			expectedRoles: [ 999 ],
			breadcrumb: 'Design Studio',
			label: 'Design Studio'
		},
    loadChildren: () => import('./dev-center/dev-center.module').then(m => m.DevCenterModule)
	  },
	  	  {
	    path: 'userwhitelist',
      loadChildren: () => import('./userwhitelist/userwhitelist.module').then(m => m.UserWhiteListModule),
	    data: {
      		label: 'USERWHITELIST'
		}
	  },
	  {
	    path: 'solvaysite',
      loadChildren: () => import('./solvaysite/solvaysite.module').then(m => m.SolvaySiteModule),
	    data: {
      		label: 'SOLVAYSITE'
		}
	  },
	  {
	    path: 'results',
      loadChildren: () => import('./results/results.module').then(m => m.ResultsModule),
	    data: {
      		label: 'RESULTS'
		}
	  },
	  {
	    path: 'userblacklist',
      loadChildren: () => import('./userblacklist/userblacklist.module').then(m => m.UserBlackListModule),
	    data: {
      		label: 'USERBLACKLIST'
		}
	  },
	  {
	    path: 'controlgroupcountry',
      loadChildren: () => import('./controlgroupcountry/controlgroupcountry.module').then(m => m.ControlGroupCountryModule),
	    data: {
      		label: 'CONTROLGROUPCOUNTRY'
		}
	  },
	  {
	    path: 'userinformation',
      loadChildren: () => import('./userinformation/userinformation.module').then(m => m.UserInformationModule),
	    data: {
      		label: 'USERINFORMATION'
		}
	  },
	  {
	    path: 'controlgroup',
      loadChildren: () => import('./controlgroup/controlgroup.module').then(m => m.ControlGroupModule),
	    data: {
      		label: 'CONTROLGROUP'
		}
	  },
	  {
	    path: 'solvaycompany',
      loadChildren: () => import('./solvaycompany/solvaycompany.module').then(m => m.SolvayCompanyModule),
	    data: {
      		label: 'SOLVAYCOMPANY'
		}
	  },
	  {
	    path: 'companyauthorization',
      loadChildren: () => import('./companyauthorization/companyauthorization.module').then(m => m.CompanyAuthorizationModule),
	    data: {
      		label: 'COMPANYAUTHORIZATION'
		}
	  },
	  {
	    path: 'appuserprivileges',
      loadChildren: () => import('./app-user-privileges/app-user-privileges.module').then(m => m.AppUserPrivilegesModule),
	    data: {
      		label: 'APP_USER_PRIVILEGES'
		}
	  },
	  {
	    path: 'changelog',
      	loadChildren: () => import('./changelog/changelog-routing.module').then(m => m.ChangeLogRoutingModule),
	    data: {
      		label: 'CHANGELOG'
		}
	  },
	  {
	    path: 'sftptrackerdashboards',
       	loadChildren: () => SftpTrackerDashboardRoutingModule,
	    data: {
      		label: 'SFTP_DASHBOARD'
		}
	  },
	  {
	    path: 'dailysynctrackerdashboard',
       	loadChildren: () => DailySyncDashboardRoutingModule,
	    data: {
      		label: 'DAILY_SYNC_DASHBOARD'
		}
	  },
	  {
	    path: 'sapdetailsdashboard',
       	loadChildren: () => SapDetailsRoutingModule,
	    data: {
      		label: 'SAP_DETAILS'
		}
	  }
	 ]
  },
  {
	path: '**',
	redirectTo: 'login',
  }
];

const config = {
  useHash: true
};

routes = extendAppRoutingModuleRoutes(routes);

@NgModule({
  imports: [ RouterModule.forRoot(routes, config) ],
  exports: [ RouterModule ],
  providers: [CanDeactivateGuard ]
})
export class AppRoutingModule { }